import React, { useState, useRef } from "react";
import { AdjustIcon, SearchIcon } from "../utils/Icons";
import Input from "./Input";
import { useClickAway } from "../hooks/useClickAway";

export default function HeaderSearchInput(props) {

    const {
        onSearch = () => { }, onAdvancedSearch = () => { },
    } = props;


    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null)

    const clickaway = useClickAway(() => {
        inputRef.current.blur();
        setFocused(false);
    }, focused)

    const submitSearch = () => {
        const input = inputRef.current;
        const term = input?.value.trim();

        if (!term) return;

        input.value = "";
        input.blur();
        setFocused(false);

        onSearch(term);
    };

    return (
        <div style={{ width: "100%", minWidth: 0, boxSizing: "border-box", }} ref={clickaway} className={`ui-icon-input-wrapper`}>
            <button type="button" className="ui-icon-input-icon" onClick={submitSearch} tabIndex={-1} >
                <div style={{ "marginTop": "-2px" }}>{<SearchIcon height={"30px"} width={"20px"} />}</div>
            </button>

            <input id="header-product-search" ref={inputRef} onClick={() => setFocused(true)} onKeyDown={(e) => {

                if (e.key === "Escape") {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.blur();
                    setFocused(false);
                    return;
                }

                if (e.key === "F2") {
                    e.preventDefault();
                    e.stopPropagation();

                    if (!e.repeat) {
                        onAdvancedSearch(e.nativeEvent);
                    }

                    return;
                }

                if (e.key === "Enter") {
                    e.preventDefault();
                    e.stopPropagation();

                    if (!e.repeat) {
                        submitSearch();
                    }
                }
            }} placeholder="Keyword product search" className="ui-select-input ui-icon-input" />
            <button type="button" className="ui-icon-input-icon" onClick={() => onAdvancedSearch()} tabIndex={-1} >
                {<AdjustIcon />}
            </button>
        </div>
    );

}

